import { gql } from '@apollo/client';

export default class AccountingMutation {
    static CREATE_CHECK = gql`
        mutation createCheck($record: CheckInput!) {
            createCheck(record: $record)
        }
    `;

    static UPDATE_CHECK = gql`
        mutation updateCheck($record: CheckInput!) {
            updateCheck(record: $record)
        }
    `;

    static CREATE_UPDATE_CHECK_FROM_INVOICE = gql`
        mutation createUpdateCheckFromInvoice($record: CheckInput!) {
            createUpdateCheckFromInvoice(record: $record)
        }
    `;

    static CREATE_DEPOSIT = gql`
        mutation createDeposit($record: DepositInput!) {
            createDeposit(record: $record)
        }
    `;

    static UPDATE_DEPOSIT = gql`
        mutation updateDeposit($record: DepositInput!) {
            updateDeposit(record: $record)
        }
    `;

    static CREATE_UPDATE_DEPOSIT_BATCH_OUT = gql`
        mutation createUpdateDepositBatchOut($record: DepositInput!) {
            createUpdateDepositBatchOut(record: $record)
        }
    `;

    static CREATE_UPDATE_TRANSFER = gql`
        mutation createUpdateTransfer($record: TransferInput!) {
            createUpdateTransfer(record: $record)
        }
    `;

    static APPROVE_CHECKS = gql`
        mutation approveChecks($checks: [Int!]!) {
            approveChecks(checks: $checks)
        }
    `;

    static VOID_CHECK = gql`
        mutation voidCheck($cbId: Int!, $forceVoid: Boolean!, $dateToPost: Date, $forceFromSold: Boolean) {
            voidCheck(cbId: $cbId, forceVoid: $forceVoid, dateToPost: $dateToPost, forceFromSold: $forceFromSold){
                success
                lockedDate
                isLockedDate
            }
        }
    `;

    static VOID_DEPOSIT = gql`
        mutation voidDeposit($cbId: Int!, $forceVoid: Boolean!, $dateToPost: Date, $forceFromSold: Boolean) {
            voidDeposit(cbId: $cbId, forceVoid: $forceVoid, dateToPost: $dateToPost, forceFromSold: $forceFromSold){
                success
                lockedDate
                isLockedDate
            }
        }
    `;

    static PRINT_CHECK = gql`
        mutation printCheck($cbIds: [Int!]!) {
            printCheck(cbIds: $cbIds)
        }
    `;

    static REPRINT_CHECK = gql`
        mutation reprintCheck($cbIds: [Int!]!, $newCheckNumber: Int, $useSameCheckNumber: Boolean) {
            reprintCheck(cbIds: $cbIds, newCheckNumber: $newCheckNumber, useSameCheckNumber: $useSameCheckNumber)
        }
    `;

    static ASSIGN_PAYMENT = gql`
        mutation assignPayment($record: AssignPaymentInput!){
            assignPayment(record: $record)
        }
    `;

    static PRINT_REMITTANCE = gql`
        mutation printRemittance($cbId: Int!, $printDate: String) {
            printRemittance(cbId: $cbId, printDate: $printDate)
        }
    `;

    static MOVING_GL_BETWEEN_ACCOUNTS = gql`
        mutation movingGlBetweenAccounts($record: OverrideAccountInput!){
            movingGlBetweenAccounts(record: $record)
        }
    `;

    static SEND_SMS_SMART_LINK = gql`
        mutation sendSMSSmartLink($accountNumber: Int!, $processType: String!, $reason: String!) {
            sendSMSSmartLink(accountNumber: $accountNumber, processType: $processType, reason: $reason)
        }
    `;

    static SEND_EMAIL_SMART_LINK = gql`
        mutation sendEmailSmartLink($accountNumber: Int!, $processType: String!, $reason: String!) {
            sendEmailSmartLink(accountNumber: $accountNumber, processType: $processType, reason: $reason)
        }
    `;

    static UNDO_APPROVAL_CHECKS = gql`
        mutation undoApproveChecks($checks: [Int!]!) {
            undoApproveChecks(checks: $checks)
        }
    `;

    static CREATE_UPDATE_CHECK_FROM_PARTS = gql`
        mutation createUpdateCheckFromParts($record: CheckInput!) {
            createUpdateCheckFromParts(record: $record)
        }
    `;

    static DELETE_ACCOUNTING_DOCUMENTS_TEMPORARY_REFERENCE = gql`
        mutation deleteAccountingDocumentsByTemporaryReference(
            $temporaryName: String!
        ) {
            deleteAccountingDocumentsByTemporaryReference(temporaryName: $temporaryName)
        }
    `;

    static UPDATE_ACCOUNTING_DOCUMENTS_REFERENCE_ID = gql`
        mutation updateAccountingDocumentsReferenceId(
            $referenceId: Int!, $temporaryName: String!
        ) {
            updateAccountingDocumentsReferenceId(referenceId: $referenceId, temporaryName: $temporaryName)
        }
    `;

    static CREATE_ACCOUNTING_DOCUMENTS = gql`
        mutation createAccountingDocuments(
            $referenceId: Int!, $referenceType: String!, $temporaryName: String, $input: [DocumentInput!]!
        ) {
            createAccountingDocuments(referenceId: $referenceId, referenceType: $referenceType, temporaryName: $temporaryName, input: $input)
        }
    `;

    static EDIT_ACCOUNTING_DOCUMENT_NAME = gql`
        mutation editAccountingDocumentName(
            $documentId: Int!, $name: String!
        ) {
            editAccountingDocumentName(documentId: $documentId, name: $name)
        }
    `;

    static DELETE_ACCOUNTING_DOCUMENT = gql`
        mutation deleteAccountingDocument(
            $documentId: Int!
        ) {
            deleteAccountingDocument(documentId: $documentId)
        }
    `;
}
